import {
  GlobeAltIcon,
  ChatBubbleLeftRightIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

import YouTube from "react-youtube";

const features = [
  {
    name: "Faster Documentation",
    description:
      "Save hours every day as AI quickly documents your prompts into SOAP.",
    icon: ChatBubbleLeftRightIcon,
  },
  {
    name: "Accurate, Comprehensive Notes",
    description:
      "No key details missed; NLP AI will learn from your SOAPs to make perfect notes.",
    icon: GlobeAltIcon,
  },
  {
    name: "Improved Work-Life Balance",
    description:
      "Doctors' lives transformed as clinic work is completed in the clinic.",
    icon: UsersIcon,
  },
];

export default function Features() {
  return (
    <div id="features" className="bg-white pt-24 sm:pt-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-4xl font-header tracking-tight text-gray-900 sm:text-6xl text-center">
          Transform Your Evenings
        </h2>
        <div className="mx-auto mt-20 max-w-2xl  lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="flex flex-col h-full justify-between p-4  py-6 rounded-xl  bg-white "
              >
                <dt className="font-semibold  flex flex-col items-center justify-center leading-7 text-zinc-900 text-2xl">
                  <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50">
                    <feature.icon
                      className="h-12 w-12 text-drDocBlue"
                      aria-hidden="true"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-5 flex flex-auto flex-col  items-center justify-center text-center  text-lg leading-7 text-zinc-600">
                  <p className="h-max">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="hidden lg:flex mx-auto mt-20 max-w-2xl lg:max-w-none flex justify-center">
          <img src="/demo.gif" alt="Demo gif of product" />
        </div>
        <div className="lg:hidden mx-auto mt-20 max-w-2xl lg:max-w-none flex justify-center">
          <img src="/demo.gif" alt="Demo gif of product" />
        </div>
      </div>
    </div>
  );
}
